import {graphql} from 'gatsby'
import React from 'react'

import RichText, {hasRichText} from '@/components/rich-text'
import {Statistics} from '@/components/statistics'
import type {StatisticsSliceFragment, StatisticsFragment} from '@/graphql-types'

type Props = {
    slice: StatisticsSliceFragment | StatisticsFragment
}

export const StatisticsSlice = React.forwardRef<HTMLDivElement, Props>(({slice}, ref) => {
    const sourceText =
        slice.primary.predefined_statistics.document?.data.source_text.richText ??
        slice.primary.source_text.richText

    return (
        <Statistics
            ref={ref}
            firstStat={{
                amount:
                    slice.primary.predefined_statistics.document?.data.first_stat[0].amount ??
                    slice.primary.first_stat_amount,
                text:
                    slice.primary.predefined_statistics.document?.data.first_stat[0].text ??
                    slice.primary.first_stat_text,
                asPercentile:
                    slice.primary.predefined_statistics.document?.data.first_stat[0]
                        .as_percentile ?? slice.primary.first_stat_as_percentile,
            }}
            secondStat={{
                amount:
                    slice.primary.predefined_statistics.document?.data.second_stat[0].amount ??
                    slice.primary.second_stat_amount,
                text:
                    slice.primary.predefined_statistics.document?.data.second_stat[0].text ??
                    slice.primary.second_stat_text,
                asPercentile:
                    slice.primary.predefined_statistics.document?.data.second_stat[0]
                        .as_percentile ?? slice.primary.second_stat_as_percentile,
            }}
            thirdStat={{
                amount:
                    slice.primary.predefined_statistics.document?.data.third_stat[0].amount ??
                    slice.primary.third_stat_amount,
                text:
                    slice.primary.predefined_statistics.document?.data.third_stat[0].text ??
                    slice.primary.third_stat_text,
                asPercentile:
                    slice.primary.predefined_statistics.document?.data.third_stat[0]
                        .as_percentile ?? slice.primary.third_stat_as_percentile,
            }}
            sourceText={
                hasRichText(sourceText) && (
                    <RichText $color="muted" content={sourceText} $variant="paragraph-base" />
                )
            }
        />
    )
})

export const statisticsSliceFragment = graphql`
    fragment StatisticsSlice on PrismicSlicePageDataBodyStats {
        __typename
        primary {
            first_stat_amount
            first_stat_text
            first_stat_as_percentile
            second_stat_amount
            second_stat_text
            second_stat_as_percentile
            third_stat_amount
            third_stat_text
            third_stat_as_percentile
            source_text {
                richText
            }
            predefined_statistics {
                document {
                    ... on PrismicStatisticsSection {
                        data {
                            first_stat {
                                amount
                                text
                                as_percentile
                            }
                            second_stat {
                                amount
                                text
                                as_percentile
                            }
                            third_stat {
                                amount
                                text
                                as_percentile
                            }
                            source_text {
                                richText
                            }
                        }
                    }
                }
            }
        }
    }
`
